import { useState, forwardRef } from 'react';
import { IconEye, IconEyeOff } from './Icons';

// Drop-in replacement for <input type="password" ... /> that adds a show/hide
// eye toggle -- forwards every prop (including a ref, since a couple of forms
// call .focus() on their password field) to the underlying input, so it
// works as a straight swap in any existing form regardless of that form's
// own input styling (className is passed through).
const PasswordInput = forwardRef(({ wrapperClassName = '', wrapperStyle, iconSize = 16, ...inputProps }, ref) => {
  const [visible, setVisible] = useState(false);
  return (
    <div className={`pw-input-wrap ${wrapperClassName}`} style={wrapperStyle}>
      <input {...inputProps} ref={ref} type={visible ? 'text' : 'password'} />
      <button
        type="button"
        className="pw-toggle-btn"
        onClick={() => setVisible((v) => !v)}
        aria-label={visible ? 'Hide password' : 'Show password'}
        tabIndex={-1}
      >
        {visible ? <IconEyeOff size={iconSize} /> : <IconEye size={iconSize} />}
      </button>
    </div>
  );
});

export default PasswordInput;
